<template>
    <van-tabs v-model="tabName" style="margin-top: 1vh" type="card" color="#f275b6">
        <van-tab title="设备查询" name="device">
            <van-form style="margin-top: 2vh" label-width="8em" input-align="center">
                <van-cell-group>
                    <van-field
                        v-model.trim="deviceCategory"
                        :readonly="true"
                        label="设备种类"
                        placeholder="请选择设备种类"
                        @click="showDeviceCategory = true"
                    />
                    <van-popup v-model="showDeviceCategory" position="bottom">
                        <van-picker
                            show-toolbar
                            :columns="deviceCategoryList"
                            @confirm="dcpConfirm"
                            @cancel="showDeviceCategory = false"
                        />
                    </van-popup>
                    <van-field label="请选择查询类型">
                        <template #input>
                            <van-radio-group v-model="searchType" direction="horizontal">
                                <van-radio name="registerCode">注册代码</van-radio>
                                <van-radio name="useRegisterCode">使用登记证编号</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                    <van-field
                        v-show="searchType === 'registerCode'"
                        v-model.trim="registerCode"
                        label="注册代码"
                        placeholder="请输入注册代码"
                    />
                    <van-field
                        v-show="searchType === 'useRegisterCode'"
                        v-model.trim="useRegisterCode"
                        label="使用登记证编号"
                        label-width="8em"
                        placeholder="请输入使用登记证编号"
                    />
                    <van-field
                        v-model.trim="startDate"
                        label="下次检验开始日期"
                        placeholder="请选择下次检验开始日期"
                        readonly
                        @click="showDatePicker('0')"
                    />
                    <van-field
                        v-model.trim="endDate"
                        label="下次检验结束日期"
                        placeholder="请选择下次检验结束日期"
                        readonly
                        @click="showDatePicker('1')"
                    />
                    <van-popup v-model="isShowDatePicker" position="bottom">
                        <van-datetime-picker
                            v-model="currentDate"
                            type="date"
                            @cancel="cancelPop"
                            @confirm="confirmPop"
                        />
                    </van-popup>
                </van-cell-group>
            </van-form>
        </van-tab>
        <van-tab title="微信报检查询" name="process">
            <van-form style="margin-top: 2vh">
                <van-cell-group>
                    <van-field
                        v-model.trim="inspectionPhone"
                        label="报检手机号"
                        type="tel"
                        placeholder="请输入报检手机号"
                        :required="true"
                    />
                    <van-field
                        v-model.trim="sms"
                        :clearable="true"
                        type="number"
                        label="短信验证码"
                        placeholder="请输入短信验证码"
                        :required="true"
                    >
                        <template #button>
                            <van-button
                                size="small"
                                type="primary"
                                :disabled="btnStatus"
                                @click="sendSms"
                            >
                                {{ spanContent }}
                            </van-button>
                        </template>
                    </van-field>
                </van-cell-group>
            </van-form>
        </van-tab>
        <van-tab v-if="area === 'jinan'" title="在线缴费" name="pay">
            <van-form style="margin-top: 2vh">
                <van-cell-group>
                    <van-field
                        v-model.trim="inspectionPhone"
                        label="报检手机号"
                        type="tel"
                        placeholder="请输入报检手机号"
                        :required="true"
                    />
                    <van-field
                        v-model.trim="sms"
                        :clearable="true"
                        type="number"
                        label="短信验证码"
                        placeholder="请输入短信验证码"
                        :required="true"
                    >
                        <template #button>
                            <van-button
                                size="small"
                                type="primary"
                                :disabled="btnStatus"
                                @click="sendSms"
                            >
                                {{ spanContent }}
                            </van-button>
                        </template>
                    </van-field>
                </van-cell-group>
            </van-form>
        </van-tab>
        <van-button
            style="margin: 2vh 5vw;width: 90vw"
            size="small"
            round
            block
            color="#f275b6"
            @click="search"
        >
            查询
        </van-button>
        <p
            v-show="tabName === 'device'"
            style="font-size: 2.5vw;width: 100%;text-align: center;color:rgba(105,105,105,1);"
        >
            注：设备种类为必选项，注册代码与使用登记证号选其一输入，下次检验日期可不选。
        </p>
    </van-tabs>
</template>

<script>
import deviceCategoryMap from '@/dictionaries/DeviceCategory'
import regex from '@/utils/Regex'
import { Dialog } from 'vant'

export default {
    name: 'InspectionDeclaration',
    data() {
        return {
            area: process.env.VUE_APP_city,
            tabName: 'device',
            isShowDatePicker: false,
            inspectionDateType: '0',
            registerCode: '',
            reportFormNumber: '',
            currentDate: new Date(),
            startDate: '',
            endDate: '',
            useRegisterCode: '',
            phone: '',
            sms: '',
            inspectionPhone: '',
            spanContent: '获取验证码',
            btnStatus: false,
            deviceCategory: '',
            deviceCategoryList: [
                '锅炉',
                '压力容器',
                '电梯',
                '起重机械',
                '场（厂）内专用机动车辆',
                '大型游乐设施',
                '压力管道元件',
                '压力管道'
            ],
            showDeviceCategory: false,
            deviceCategoryError: false,
            searchType: 'registerCode'
        }
    },
    mounted: function() {},
    methods: {
        search() {
            switch (this.tabName) {
                case 'device':
                    this.deviceSearch()
                    break
                case 'process':
                    this.processSearch()
                    break
                case 'pay':
                    this.paySearch()
                    break
            }
        },
        showDatePicker(type) {
            this.inspectionDateType = type
            this.isShowDatePicker = true
        },
        cancelPop() {
            this.isShowDatePicker = false
        },
        formatDate(date) {
            let d = new Date(date)
            let month = String(d.getMonth() + 1)
            let day = String(d.getDate())
            let year = d.getFullYear()
            if (month.length < 2) month = '0' + month
            if (day.length < 2) day = '0' + day
            return [year, month, day].join('-')
        },
        confirmPop(val) {
            this.currentDate = val
            if (this.inspectionDateType === '0') {
                this.startDate = this.formatDate(val)
            } else {
                this.endDate = this.formatDate(val)
            }
            this.isShowDatePicker = false
        },
        sendSms() {
            if (this.inspectionPhone === '') {
                Dialog.alert({
                    title: '提示',
                    message: '请输入报检手机号!',
                    theme: 'round-button'
                })
            } else {
                const reg = regex.allSMSNumbers
                if (reg.test(this.inspectionPhone)) {
                    this.btnStatus = true
                    let flag = false
                    let time = 60
                    let timeID = setInterval(() => {
                        if (flag) {
                            clearInterval(timeID)
                        } else {
                            this.spanContent = `${time}s后重试`
                            time--
                            if (time === 0) {
                                this.btnStatus = false
                                flag = true
                                time = 60
                                this.spanContent = '重新获取'
                            }
                        }
                    }, 1000)
                    this.axios
                        .get(`http://101.37.88.238:8080/sms/sms/captcha/${this.inspectionPhone}`, {
                            headers: { area: process.env.VUE_APP_city }
                        })
                        .then((response) => {
                            if (response.status === 209) {
                                this.btnStatus = false
                                flag = true
                                this.spanContent = '重新获取'
                                alert('验证码已经发送!')
                            } else if (response.status !== 200) {
                                this.btnStatus = false
                                flag = true
                                this.spanContent = '重新获取'
                                alert(`短信发送异常，错误是：${response.data.description}`)
                            }
                        })
                } else {
                    alert('请输入正确的手机号！')
                }
            }
        },
        dcpConfirm(value) {
            this.deviceCategory = value
            this.showDeviceCategory = false
        },
        deviceSearch() {
            if (this.deviceCategory === '') {
                Dialog.alert({
                    title: '提示',
                    message: '请选择设备种类!',
                    theme: 'round-button'
                })
            } else if (this.registerCode === '' && this.useRegisterCode === '') {
                Dialog.alert({
                    title: '提示',
                    message: '注册代码与使用登记编号必须填一个!',
                    theme: 'round-button'
                })
            } else {
                if (this.searchType === 'registerCode') {
                  this.useRegisterCode = ''
                }else {
                  this.registerCode= ''
                }
                this.$router.push({
                    path: '/devicelist',
                    query: {
                        deviceCategory: this.deviceCategory,
                        deviceCategoryCode: deviceCategoryMap.get(this.deviceCategory),
                        zcdm: this.registerCode,
                        sydjbh: this.useRegisterCode,
                        xcjyrqks: this.startDate,
                        xcjyrqjs: this.endDate
                    }
                })
            }
        },
        processSearch() {
            if (this.inspectionPhone === '') {
                Dialog.alert({
                    title: '提示',
                    message: '请输入报检手机号!',
                    theme: 'round-button'
                })
            } else if (this.sms === '') {
                Dialog.alert({
                    title: '提示',
                    message: '请输入验证码!',
                    theme: 'round-button'
                })
            } else {
                this.axios
                    .post(
                        `http://101.37.88.238:8080/sms/sms/captcha/${this.inspectionPhone}?sms=${this.sms}`
                    )
                    .then(() => {
                        this.$router.push({
                            path: `/form-list/${this.inspectionPhone}`,
                            query: {
                                type: 'inspection'
                            }
                        })
                    })
                    .catch((error) => {
                        Dialog.alert({
                            title: '提示',
                            message: '请输入正确的验证码!',
                            theme: 'round-button'
                        })
                    })
            }
        },
        paySearch() {
            if (this.inspectionPhone === '') {
                Dialog.alert({
                    title: '提示',
                    message: '请输入报检手机号!',
                    theme: 'round-button'
                })
            } else if (this.sms === '') {
                Dialog.alert({
                    title: '提示',
                    message: '请输入验证码!',
                    theme: 'round-button'
                })
            } else {
                this.axios
                    .post(
                        `http://101.37.88.238:8080/sms/sms/captcha/${this.inspectionPhone}?sms=${this.sms}`
                    )
                    .then(() => {
                        this.$router.push({
                            path: `/charge-form-list/${this.inspectionPhone}`,
                            query: {
                                type: 'charge'
                            }
                        })
                    })
                    .catch((error) => {
                        Dialog.alert({
                            title: '提示',
                            message: '请输入正确的验证码!',
                            theme: 'round-button'
                        })
                    })
            }
        }
    }
}
</script>

<style>
.van-field__label {
    display: flex;
    align-items: center;
}
</style>
